module.exports = __webpack_public_path__ + "static/media/pacificheights.7d220e3a.jpg";